<template>
  <div>
    <section-header
      id="reviews"
      :departmentId="departmentId"
      :swiftMove="swiftMove"
      >Reviews
    </section-header>
    <v-btn v-if="copy == null" @click="createNew" small>
      <v-icon>add</v-icon> Review
    </v-btn>
    <v-form ref="reviewForm" v-if="copy">
      <div class="ajaxForm">
        <v-select
          label="Choose review site"
          v-model="copy.reviewsiteid"
          :items="reviewSites"
          item-value="id"
          item-text="name"
          :rules="valueRules"
          outline
        ></v-select>
        <v-input
          label="Rating"
          outline
          :rules="valueRules"
          :value="copy.rating"
        >
          <star-rating v-model="copy.rating" />
        </v-input>
        <v-text-field label="Name" v-model="copy.name" outline />
        <v-text-field label="Subject" v-model="copy.subject" outline />
        <v-textarea label="Body" v-model="copy.body" outline />
        <v-text-field label="Url" v-model="copy.url" outline />
        <v-btn @click="saveReview"> <v-icon>save</v-icon> Save</v-btn>
        <v-btn @click="copy = null"> Cancel </v-btn>
      </div>
    </v-form>
    <div v-if="!computedReviewsPresent">No reviews</div>
    <v-data-table
      v-if="computedReviewsPresent"
      :headers="headers"
      :items="reviews"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn @click="fetchReview(props.item.id)">{{
              props.item.id
            }}</v-btn>
          </td>
          <td>
            <span>{{ props.item.reviewsite.name }}</span>
            <a :href="props.item.url" target="_blank" v-if="props.item.url"
              ><v-icon>open_in_new</v-icon></a
            >
          </td>
          <td>
            <star-rating
              v-model="props.item.rating"
              :star-size="20"
              read-only
            />
          </td>
          <td><EntityZ :entity="props.item.user" format="system" /></td>
          <td>{{ props.item.timestamp | formatDate }}</td>
          <td>
            <v-btn @click="deleteReview(props.item.id)" small>Delete</v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="3000"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import nbmlaw from "@/api/nbmlaw";
import EntityZ from "@/components/link/EntityZ";
import SectionHeader from "@/components/file/SectionHeader";
export default {
  name: "Reviews",
  props: ["departmentId", "swiftMove"],
  components: {
    EntityZ,
    SectionHeader,
    StarRating
  },
  computed: {
    computedReviewsPresent() {
      return this.reviews && this.reviews.length;
    }
  },
  data() {
    return {
      reviewSites: null,
      reviews: null,
      review: null,
      copy: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Review site",
          value: "reviewsite.name"
        },
        {
          text: "Rating",
          value: "rating"
        },
        {
          text: "User",
          value: "user.name"
        },
        {
          text: "Timestamp",
          value: "timestamp"
        },
        {
          text: " ",
          sortable: false
        }
      ],
      snackbar: false,
      snackbarText: null,
      valueRules: [(v) => !!v || "Value is required"]
    };
  },
  methods: {
    async fetchReviewSites() {
      const response = await nbmlaw.get(`/cors/admin/directory/reviewSites`);
      // console.log(response.data)
      this.reviewSites = response.data;
    },
    async fetchReviews() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.id}/reviews`
      );
      //   console.log(response.data);
      this.reviews = response.data;
    },
    async fetchReview(id) {
      const response = await nbmlaw.get(`/cors/admin/directory/reviews/${id}`);
      // console.log(response.data);
      this.review = response.data;
    },
    async saveReview() {
      try {
        if (this.$refs.reviewForm.validate()) {
          this.review ? await this.updateReview() : await this.createReview();
          // console.log(response.data);
          this.fetchReviews();
          this.copy = null;
          this.review = null;
        }
      } catch (err) {
        // console.log(err);
        this.snackbar = true;
        this.snackbarText = `There was an error`;
      }
    },
    async createReview() {
      await nbmlaw.post(
        `/cors/admin/file/files/${this.$route.params.id}/reviews`,
        this.copy
      );
    },
    async updateReview() {
      await nbmlaw.put(
        `/cors/admin/directory/reviews/${this.review.id}`,
        this.copy
      );
    },
    async deleteReview(id) {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(`/cors/admin/directory/reviews/${id}`);
        this.fetchReviews();
      }
    },
    createNew() {
      this.copy = {
        reviewsiteid: null,
        rating: null,
        name: null,
        subject: null,
        body: null,
        url: null
      };
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchReviews();
      }
    },
    review: {
      handler() {
        if (this.review) {
          this.copy = JSON.parse(JSON.stringify(this.review));
          if (this.review.reviewsite) {
            this.copy.reviewsiteid = this.review.reviewsite.id;
          }
        }
      }
    }
  },
  created() {
    this.fetchReviewSites();
  }
};
</script>